import 'assets/styles/keen/theme01/layout/brand/light.css';
import AppResource from 'general/constants/AppResource';
import useRouter from 'hooks/useRouter';
import { useEffect } from 'react';
import './style.scss';

function KT01HeaderMobile(props) {
  const router = useRouter();

  // MARK: --- Hooks ---
  useEffect(() => {
    if (typeof KTLayoutHeaderMobile !== undefined) {
      KTLayoutHeaderMobile.init('kt_header_mobile');
    }

    if (typeof KTLayoutHeaderTopbar !== undefined) {
      KTLayoutHeaderTopbar.init('kt_header_mobile_topbar_toggle');
    }
  }, []);

  return (
    <div
      id="kt_header_mobile"
      className="header-mobile align-items-center header-mobile-fixed w-50"
    >
      {/* toolbar */}
      <div className="d-flex align-items-center">
        {/* button sidebar toggle */}
        <button id="kt_aside_mobile_toggle" className="btn p-0 burger-icon burger-icon-left">
          <span className="svg-icon svg-icon-xxl"></span>
        </button>

        {/* logo */}
        <a
          href="#"
          className="mx-4"
          onClick={(e) => {
            e.preventDefault();
            router.navigate('/');
          }}
        >
          {/* <img id="logo" src={AppResource.icons.evg.evgLogo} alt="logo" /> */}
        </a>
      </div>
    </div>
  );
}

export default KT01HeaderMobile;
